/** 样式 */
<style lang="scss" src="./BimEngineeringChangeItemDetail.vue.scss"></style>
<template>
  <div>
    <div
      v-dialogDrag
      class="table bimEngineeringChangeItemDetail no-select"
      style="margin: 105px 0px 0px -727px"
    >
      <h3 class="canmove">
        变更详情面版<i class="el-icon-close" @click="hutDown"></i>
      </h3>
      <!-- <i class="el-icon-arrow-down"></i> -->
      <el-tabs
        type="border-card"
        :class="{ onlyOneTab: activeName == 'tab-file' }"
        @tab-click="handleClick"
        v-model="activeName"
      >
        <el-tab-pane
          name="tab-file"
          class="tab-file"
          v-if="activeName == 'tab-file'"
        >
          <span slot="label"
            ><i class="el-icon-renfanggongchengshigongtushejiwenjianshencha"></i
            >文档与图纸</span
          >
          <div class="wrapper">
            <!-- <div class="radios">
              <el-radio v-model="fileType" :label="1">图纸</el-radio>
              <el-radio v-model="fileType" :label="2">文档</el-radio>
            </div> -->
            <!-- <div class="searchInput">
              <span>查找</span>
              <el-input
                placeholder="请输入内容"
                v-model="keyword"
                @input="inputChange"
                clearable
              >
              </el-input>
            </div> -->
            <div class="fileList">
              <h4>文件列表</h4>

              <el-scrollbar style="height: 232px; width: 290px">
                <el-upload
                  action="#"
                  :http-request="uploadFileBtnClick"
                  :limit="1"
                  class="upload-demo"
                  :on-remove="handleRemove"
                  :on-preview="handlePreview"
                  :before-remove="beforeRemove"
                  :file-list="fileList"
                >
                  <el-button size="small">点击上传</el-button>
                </el-upload>
              </el-scrollbar>
              <!-- <el-button @click="uploadFileBtnClick"
              ><i class="el-icon-zengjia"></i>{{btnText}}
            </el-button> -->
              <p>允许上传不超过5MB的图片和文档文件。</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="tab-property">
          <span slot="label"
            ><i class="el-icon-jianshexinxijicheng"></i>属性</span
          >
          <el-scrollbar style="height: 263px; width: 282px">
            <el-table :data="attribute_data" width="267">
              <el-table-column prop="key" label="属性" width="96" align="left">
              </el-table-column>
              <el-table-column prop="value" label="值" width="171" align="left">
              </el-table-column>
            </el-table>
          </el-scrollbar>
          <div class="btns">
            <el-button @click="DownloadthePropertyTemplate">下载模板</el-button>
            <!-- <el-button>导入数据</el-button> -->
            <el-upload
              class="upload-demo"
              action="#"
              :http-request="ClickAttribute"
              :limit="1"
              :file-list="attribute_data"
            >
              <el-button>导入数据</el-button>
            </el-upload>
          </div>
        </el-tab-pane>
        <el-tab-pane name="tab-cost">
          <span slot="label"><i class="el-icon-yunweixinxi"></i>造价信息</span>
          <el-scrollbar style="height: 263px; width: 282px">
            <el-table :data="cost_data" width="267">
              <el-table-column prop="type" label="类型" width="96" align="left">
              </el-table-column>
              <el-table-column prop="unitPrice" label="单价（元）" align="left">
              </el-table-column>
              <el-table-column
                prop="totalUnitPrice"
                label="合计（元）"
                align="left"
              >
              </el-table-column>
            </el-table>
          </el-scrollbar>
          <div class="btns">
            <el-button @click="DownloadthePropertyCostdata">下载模板</el-button>
            <el-upload
              class="upload-demo"
              action="#"
              :http-request="uploadFileBtnClickCostdata"
              :limit="1"
              :file-list="cost_data"
            >
              <el-button>导入数据</el-button>
            </el-upload>

            <!-- <el-button>导入数据</el-button> -->
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :modal="true"
        @close="dialogVisible = false"
      >
        <img width="100%" :src="dialogImageUrl" alt="" />
        <!-- {{dialogImageUrl}} -->
      </el-dialog>
    </div>

    <div
      v-show="0"
      v-dialogDrag
      class="table bimEngineeringChangeItemDetail no-select"
      style="width: 180px; height: 27px"
    >
      <h3 class="canmove" v-show="bimEngineeringChangeItemDetail_show">
        竣工交付功能面板<i
          class="el-icon-close"
          @click="bimEngineeringChangeItemDetail_click"
        ></i
        ><i class="el-icon-arrow-up" @click="isFold = false"></i>
      </h3>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import * as echarts from "echarts";
let showChart;

//按需加载
import {
  BimEngineeringChangeItemCost, //造价列表查询
  getBimengineeringchangeitemdetail, //详情列表查询
  getFileList,
} from "../../../../api/api";

export default {
  components: {},
  props: ["hutDown", "detailData"],
  data() {
    return {
      id: "",
      tabshow: false,
      activeName: "tab-file",
      bimEngineeringChangeItemDetail_show: false,
      // btnText: "上传图纸",
      fileType: 1,
      fileList: [], //父结点的
      tempFileList: [], //还未保存到服务器上的用户上传的文件。
      fileData: "", //文件上传数据（多文件合一）。
      dialogVisible: false,
      dialogImageUrl: "",
      keyword: "",
      currentBtn: 1, // 临时做展示效果用。
      isFold: false,
      attribute_data: [], //子节点的属性
      cost_data: [], //子节点的造价
      faData: {}, //接收父组件传递过来的值
    };
  },
  watch: {
    detailData: function(newVal, oldVal) {
      console.log(newVal); //获取传递过来的参数对象
      if (newVal.children.length == 0) {
        this.activeName = "tab-property";
      } else {
        this.activeName = "tab-file";
      }
      this.faData = newVal;
    },
  },
  mounted() {
    // this.$refs["multipleTable"].$nextTick(function () {
    //   this.escrollY(".el-table__body-wrapper", ".el-table__header-wrapper");
    //   console.log("触发！");
    // });
    // this.showFileList = this.fileList;
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
    this.getCostList();
  },
  computed: {
    btnText: function() {
      return this.fileType === 2 ? "上传文档" : "上传图纸";
    },
    opBtnText: function() {
      return this.currentBtn === 7 ? "竣工信息" : "摄像头标记";
    },
  },

  methods: {
    // 获取变更造价明细表列表
    getCostList() {
      let modelData = {
        ProjectId: this.faData.bimEngineeringChangeItem.projectId,
        ItemId: this.faData.bimEngineeringChangeItem.id,
      };
      BimEngineeringChangeItemCost(modelData).then((res) => {
        this.cost_data = res.data.data;
      });
    },
    init() {
      //初始化方法   默认获取属性的参数
      console.log("初始化方法11111");
      //
      if (this.faData.children.length == 0) {
        this.DetailsList(0);
        this.getCostList();
      } else {
        this.getListData(this.faData.id);
      }
    },
    getListData(id) {
      let tileList = [];
      let modelData = {
        businessId: id, //是树的父节点里的id啊
        businessType: "BimEngineeringChangeItem",
      };
      getFileList(modelData).then((res) => {
        console.log("测试", res.data.data);
        if (res.data.success && res.data.data.length > 0) {
          for (let i = 0; i < res.data.data.length; i++) {
            let tempObj = {
              name: res.data.data[i].fileOriginName,
              //如果要预览文件或下载文件则调用专门的api接口，因此这里不需要拼接出url。
              url: "#",
              id: res.data.data[i].id,
              //'url': process.env.VUE_APP_BASE_API + response.imgUrl
            };
            //console.log(tempObj);
            tileList.push(tempObj);
          }
          console.log(tileList);
          this.fileList = tileList;
        }
      });
    },
    //获取变更属性明细表列表
    DetailsList(type) {
      console.log("初始化类型：", type);
      let listType = type;
      this.attribute_data = [];
      let modelData = {
        ProjectId: this.faData.bimEngineeringChangeItem.projectId,
        ItemId: this.faData.bimEngineeringChangeItem.id, //this.faData.bimEngineeringChangeItem.id
        Type: type,
      };
      getBimengineeringchangeitemdetail(modelData).then((res) => {
        console.log("详情列表数据", res.data.data);
        for (let i = 0; i < res.data.data.length; i++) {
          console.log(res.data.data[i].key);
          this.attribute_data.push({
            key: res.data.data[i].key,
            value: res.data.data[i].value,
          });
        }
      });
    },
    //下载造价模板
    DownloadthePropertyCostdata() {
      console.log(22222);
      axios({
        method: "get",
        url: "/baseIP/BimEngineeringChangeItemCost/export", // 请求地址
        responseType: "blob", // 设置接收格式为blob格式
        params: {},
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + window.sessionStorage.getItem("token"),
          "X-Authorization":
            "Bearer " + window.sessionStorage.getItem("refreshToken"),
        },
      }).then((res) => {
        console.log(res);
        this.downloadFile(res);
      });
    },
    // 下载属性模板
    DownloadthePropertyTemplate() {
      console.log(11111111);
      axios({
        method: "get",
        url: "/baseIP/BimEngineeringChangeItemDetail/export", // 请求地址
        responseType: "blob", // 设置接收格式为blob格式
        params: {},
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + window.sessionStorage.getItem("token"),
          "X-Authorization":
            "Bearer " + window.sessionStorage.getItem("refreshToken"),
        },
      }).then((res) => {
        console.log(res);
        this.downloadFile(res);
      });
    },
    downloadFile(res) {
      let blob = new Blob([res.data], {
        type: "application/octet-stream;charset=UTF-8",
      });
      let contentDisposition = res.headers["content-disposition"];
      let filename = contentDisposition
        .split("=")[2]
        .replace("UTF-8", "")
        .replace("'", "")
        .replace("'", "");
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      let reg = /^["](.*)["]$/g;
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = decodeURI(filename.replace(reg, "$1")); //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放通过调用URL.createObjectURL()创建的URL对象。
    },

    bimEngineeringChangeItemDetail_click() {
      console.log("变更详情面板关闭");
      this.showInfoType = false;
      this.bimEngineeringChangeItemDetail_show = false;
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 点击上传父组件
    uploadFileBtnClick(item) {
      let formData = new FormData();
      formData.append(
        "projectId",
        window.sessionStorage.getItem("nowProjectId")
      );
      // projectId = window.sessionStorage.getItem("nowProjectId");
      formData.append("files", item.file);
      formData.append("businessId", this.id);
      formData.append("businessType", "BimEngineeringChangeItem");
      axios
        .post("/baseIP/sysFileInfo/uploadmultiple", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          console.log(res);
        });
    },
    // 子组件属性上传
    ClickAttribute(item) {
      let formData = new FormData();
      formData.append(
        "ProjectId",
        this.faData.bimEngineeringChangeItem.projectId
      );
      formData.append("File", item.file);
      formData.append("ItemId", this.faData.bimEngineeringChangeItem.id);
      formData.append("Type", 0);
      axios
        .post("/baseIP/BimChangeClassification/uploadExcel", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          console.log(res);
          this.DetailsList(0);
        });
    },
    // 子组件造价上传
    uploadFileBtnClickCostdata(item) {
      console.log(item);
      let formData = new FormData();
      formData.append(
        "ProjectId",
        this.faData.bimEngineeringChangeItem.projectId
      );
      formData.append("File", item.file);
      formData.append("ItemId", this.faData.bimEngineeringChangeItem.id);
      axios
        .post("/baseIP/BimEngineeringChangeItemCost/uploadExcel", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          console.log(res);
          this.getCostList();
        });
    },
    inputChange(val) {
      // this.fileList = this.fileList.filter(val)

      //alert(val)
      this.showFileList = this.fileList.filter((item) =>
        item.name.includes(val)
      );
    },

    cameraList() {
      this.currentBtn = 6;
    },
    completionInfoList() {
      this.currentBtn = 7;
    },
    handleClick(tab, event) {
      // this.refreshCode();
      console.log(tab.index, event);
      if (tab.index == 0) {
        //this.$refs.buildFBtn.$emit("click");
        //this.currentBtn = 1;
        //接口怎么区分哪个是属性 哪个造价信息 属性是0 造价是1 type值
        this.DetailsList(tab.index);
      } else if (tab.index == 1) {
        // this.currentBtn = 6;
        // this.btnText = "摄像头标记";
        this.DetailsList(tab.index);
      }
    },
    verifyBtnIndex(index) {
      if (this.currentBtn === index) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
